import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgColouredVolatilityLow = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={66}
    height={26}
    fill="none"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g clipPath="url(#a)">
      <rect
        width={7.5}
        height={21}
        x={7.5}
        y={22.5}
        fill="#8094B1"
        rx={1}
        transform="rotate(-180 7.5 22.5)"
      />
      <rect width={4.5} height={7.636} x={19.5} y={15} fill="url(#b)" rx={1} />
      <path
        fill="#8094B1"
        d="M10.5 11.5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-10Z"
      />
    </g>
    <path
      fill="url(#c)"
      d="M37.37 16.943V19h-6.443v-2.057h6.442Zm-5.59-10.74V19h-2.637V6.203h2.636Zm17.032 6.1v.606c0 .973-.131 1.846-.395 2.62-.264.773-.636 1.432-1.116 1.977a4.84 4.84 0 0 1-1.723 1.24c-.662.286-1.397.43-2.206.43a5.529 5.529 0 0 1-2.206-.43 4.944 4.944 0 0 1-1.723-1.24c-.486-.545-.864-1.204-1.133-1.978-.264-.773-.396-1.646-.396-2.619v-.606c0-.979.132-1.852.396-2.62.263-.773.635-1.432 1.116-1.977a4.894 4.894 0 0 1 1.722-1.248 5.53 5.53 0 0 1 2.206-.43c.81 0 1.544.143 2.206.43a4.792 4.792 0 0 1 1.723 1.248c.486.545.861 1.204 1.125 1.978.27.767.404 1.64.404 2.619Zm-2.663.606v-.624c0-.68-.061-1.277-.184-1.793-.123-.515-.305-.949-.545-1.3a2.352 2.352 0 0 0-.879-.792 2.513 2.513 0 0 0-1.186-.272c-.446 0-.841.09-1.187.272-.34.176-.63.44-.87.791-.235.352-.413.786-.536 1.301-.123.516-.185 1.113-.185 1.793v.624c0 .674.062 1.272.185 1.793.123.516.304.952.545 1.31.24.351.533.618.878.8.346.181.742.272 1.187.272.445 0 .84-.09 1.187-.273.345-.181.635-.448.87-.8.234-.357.413-.793.536-1.309.123-.521.184-1.119.184-1.793Zm7.647 4.06 2.549-10.766h1.424l.325 1.793L55.378 19h-1.53l-.052-2.03Zm-1.31-10.766 2.11 10.767L54.42 19h-1.705L49.876 6.203h2.61Zm7.849 10.723 2.083-10.723h2.61L62.198 19h-1.705l-.158-2.074ZM58.568 6.203l2.567 10.81-.07 1.987h-1.53L56.802 7.987l.351-1.784h1.415Z"
    />
    <defs>
      <linearGradient
        id="b"
        x1={0.75}
        x2={24.745}
        y1={5.25}
        y2={6.577}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E80032" />
        <stop offset={1} stopColor="#FFF347" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={25.077}
        x2={79.076}
        y1={3.792}
        y2={34.263}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E80032" />
        <stop offset={1} stopColor="#FFF347" />
      </linearGradient>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
)
const ForwardRef = forwardRef(SvgColouredVolatilityLow)
const IconSvgColouredVolatilityLow = createIcon(
  ForwardRef,
  'SvgColouredVolatilityLow',
)
export default IconSvgColouredVolatilityLow
